export default __webpack_public_path__ + "static/media/Bajaj-Finserv.20de2298.webp";